import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="wysiwyg-initiator"
export default class extends Controller {
  connect() {
    this.editors = []
    this.wait_for_assets(() => {
      window.InitEmbodiaWysiwygFromWindow().then(editors => {
        this.editors = editors
      })
    });
  }

  disconnect() {
    this.editors.forEach((editor) => editor.remove())
  }

  wait_for_assets(callback) {
    const check = () => {
      if (window.InitEmbodiaWysiwygFromWindow) {
        callback();
      } else {
        requestAnimationFrame(check); // try again on the next frame
      }
    };
    check();
  }
}
